import get from 'lodash/get';

export const selectRiskDisplayStyle = (state) => get(state, 'risk.displayStyle') || '';

export const selectSelectedProduct = (state) => get(state, 'risk.products.selected') || null;
